import { LeftArrow, RightArrow } from 'components/utils/Arrows/CarouselArrows'
import { useCarousel } from 'nuka-carousel'
import Group from 'components/utils/Group'

function CarouselArrows() {
  const { currentPage, goBack, goForward, totalPages, wrapMode } = useCarousel()

  const allowWrap = wrapMode === 'wrap'
  const enablePrevNavButton = allowWrap || currentPage > 0
  const enableNextNavButton = allowWrap || currentPage < totalPages - 1

  return <Group direction="horizontal" horizontalAlign="center">
    <LeftArrow hidden={!enablePrevNavButton} onClick={goBack} />
    <RightArrow hidden={!enableNextNavButton} onClick={goForward} />
  </Group>
}

export default CarouselArrows
